module.exports = __webpack_public_path__ + "assets/images/project/head/Han_Hyun-min.jpg?v=06bde5c0";